import { render, staticRenderFns } from "./PageBanner.vue?vue&type=template&id=6018e9f4&"
import script from "./PageBanner.vue?vue&type=script&lang=ts&"
export * from "./PageBanner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports